import { DESKTOP_MIN_WIDTH } from '@/components/blocks/PLPProductCard/constants';
import { SxProps, Theme } from '@mui/material';

export const passwordSx: {
	regular: SxProps<Theme>;
	success: SxProps<Theme>;
	error: SxProps<Theme>;
	requirementsContainer: SxProps<Theme>;
	requirementsTitle: SxProps<Theme>;
	list: SxProps<Theme>;
	listItem: SxProps<Theme>;
} = {
	regular: {
		color: 'grey.300',
	},
	success: {
		color: 'success.main',
	},
	error: {
		color: 'error.main',
	},
	requirementsContainer: (theme: Theme) => ({
		display: 'flex',
		flexDirection: 'row',
		[theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
			flexDirection: 'column',
		},
	}),

	requirementsTitle: {
		color: 'grey.500',
	},
	list: {
		listStyle: 'none',
		pt: '0',
	},
	listItem: {
		display: 'flex',
		alignItems: 'center',
		p: '0',
		pt: '5px',
		height: '15px',
		fontSize: '12px',
		'&::before': {
			content: '"•"',
			paddingRight: 1,
			fontWeight: 900,
			fontSize: '25px',
		},
	},
};
